import { styled, AppBar, Box, Button } from "@mui/material";

export const HeaderRoot = styled(AppBar)(({ theme }) => ({
  background: theme?.palette?.companyColors?.neutral,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: 0,
  boxShadow: "0px -2px 15px rgba(0,0,0,0.5)",
  zIndex: 9999,
  position: "relative",
}));

export const Divider = styled(Box)(({ theme, height }) => ({
  height: height ? height : "100%",
  position: "relative",
  width: "1px",
  display: "block",
  zIndex: 99,
  background: theme?.palette?.companyColors?.greyLight2,
}));

export const CustomButtom = styled(Button)(({ theme, active }) => ({
  width: "auto",
  margin: 0,
  padding: "0 1.5rem",
  borderRadius: 0,
  lineHeight: 1,
  fontWeight: active ? 600 : 400,
  fontSize: "1.25rem",
  height: "100%",
  textTransform: "none",
  color: theme?.palette?.companyColors?.primary,
  pointerEvents: active ? "none" : "all",
  [theme.breakpoints.up("lg")]: {
    padding: "0 3rem",
    fontSize: "1.5rem",
  },
  "&:after": {
    content: "''",
    display: "block",
    background: theme?.palette?.companyColors?.secondary,
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    width: "100%",
    height: 3,
    opacity: active ? 1 : 0,
    transition: "all 0.5s ease-in-out",
  },
}));
